import React, { useContext } from "react";
import { quoteContext } from "../../context/quotesContext";
import { Button } from "../Button";
import { StepFromAndTo } from "../StepFromAndTo";
import { ShipmentForm } from "../ShipmentForm";
import { createShipment } from "../api";
import { useTranslation } from "react-i18next";
const FirstStep = () => {
  const {
    error,
    loading,
    fromAndToCompleted,
    handleCancel,
    isFristStepComplete,
    setLoading,
    setCurrentStep,
    mapShipment,
    setError,
    setCreateShipmentResponse,
    setCurrentSubStep,
    setSelectedProvider
  } = useContext(quoteContext);
  const [t, i18n] = useTranslation();
  const handleCreateShipment = async () => {
    if (isFristStepComplete) {
      try {
        setLoading(true);
        const result = await createShipment(mapShipment);

        if (result) {
          if (result.rate_options.length === 0) {
            throw new Error();
          } else {
            setCreateShipmentResponse(result);
            setSelectedProvider(result?.rate_options[0]);
            setLoading(false);
            setError(false);
          }
        }
      } catch (error) {
        console.error("Error fetching data", error);
        setError(true);
        setLoading(false);
      } finally {
        setLoading(false);
        if (!error) {
          setCurrentSubStep(1);
          setCurrentStep(2);
        }
      }
    }
  };

  return (
    <>
      <StepFromAndTo></StepFromAndTo>
      {fromAndToCompleted && <ShipmentForm></ShipmentForm>}
      <div className="form-container-button">
        {fromAndToCompleted && (
          <a onClick={handleCancel} className="cancel">
            {t('cancel')}
          </a>
        )}
        <Button onClick={handleCreateShipment} disable={!isFristStepComplete || loading}>
          {loading ?t('loading') :t('continue')}
        </Button>
      </div>
    </>
  );
};

export { FirstStep };
